import React from 'react';
import ReactMarkdown from 'react-markdown';
import { looksLikeCommentHtml } from '../utils/comment-rich-text';

type CommentRichTextBodyProps = {
  content: string;
  className?: string;
  style?: React.CSSProperties;
};

export const CommentRichTextBody: React.FC<CommentRichTextBodyProps> = ({
  content,
  className = 'prose prose-sm max-w-none',
  style,
}) => {
  if (looksLikeCommentHtml(content)) {
    return (
      <div
        className={className}
        style={style}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }

  return (
    <div className={className} style={style}>
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
};
